export enum ETypeAppareil {
    Compteur = 1,
    Multimetre,
    // Sonometre,
    // Luxmetre,
    ApplicateurContact = 5,
    Biocollecteur = 6,
    Biocollecteur2 = 7,
}